import { Component, Input, ChangeDetectorRef } from '@angular/core';
import * as _ from 'lodash';

import { QueueProcess } from 'shared/process/queue-process.model';
import { BaseModalComponent } from '../_base-modal.component';


@Component({
  moduleId: module.id,
  selector: 'processing-modal',
  templateUrl: 'processing-modal.component.html',
  styleUrls: ['processing-modal.component.scss'],
})
export class ProcessingModalComponent extends BaseModalComponent {
  @Input() title: string = 'Making a big change?';
  @Input() text: string;
  @Input() processes: Array<QueueProcess> = [];
  @Input() hiddenCloseBtn: boolean = true;
  @Input() overflow: boolean = false;

  get processesCount(): number {
    return _.size(this.processes);
  }

  constructor(
    private ref: ChangeDetectorRef,
  ) {
    super();
  }

  onModalClose() {
    this.hide();
  }
}
